import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Popup } from 'next-common-lib';
import i18n from 'i18n';
import { KEYCODE } from 'config/type';
import * as alertActions from 'redux/ducks/common/alertDucks';

export const Alert = () => {
  const dispatch = useDispatch();
  const alert = useSelector(state => state.alert);
  const popupRef = useRef(null);
  const { t } = useTranslation();
  const mappingMessage = () => {
    const result = [];
    alert.message.forEach(msg => {
      if (msg) {
        result.push(
          typeof msg === 'object' ? msg.key ? <Trans i18nKey={msg.key} values={msg.value} /> : msg.textMgs : t(msg),
        );
      } else {
        result.push(<Trans i18nKey="CO500" />);
      }
    });
    return result;
  };

  useEffect(() => {
    if (alert.isShow) {
      popupRef.current.focus();
    }
  }, [alert.isShow]);

  return (
    <>
      {alert.isShow && (
        <Popup
          id="employee_Alert"
          ref={popupRef}
          isShow={alert.isShow}
          isDimed={alert.isShow}
          dimedClassName="has-bg"
          size="xs"
          componentType="normalPopup"
          closeFunction={
            alert.isDelCloseButton
              ? null
              : () => {
                  dispatch(alertActions.close());
                }
          }
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t(alert.title)}
            </h1>,
          ]}
          contentsComponent={mappingMessage()}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('EM_T_OK')}
                  onClick={() => {
                    alert.callback();
                    dispatch(alertActions.close());
                  }}
                />
              </div>
            </div>,
          ]}
          onKeyup={e => {
            if (e.code === KEYCODE.ENTER || e.code === KEYCODE.NUMPADENTER) {
              alert.callback();
              dispatch(alertActions.close());
            }
          }}
        />
      )}
    </>
  );
};
Alert.propTypes = {};
Alert.defaultProps = {};
export default Alert;
